function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Link, useLocation } from "@custom/schema";
import classNames from "clsx";
import React from "react";
import { useFlyout } from "../../utils/flyout";
import { useLocalization } from "../../utils/localization";
import { buildUrl, dynamicUrl } from "../../utils/url";
export var MenuItem = function MenuItem(param) {
  var url = param.url,
    title = param.title,
    attributes = param.attributes,
    childItems = param.childItems,
    childMenuAttributes = param.childMenuAttributes,
    _onClick = param.onClick,
    className = param.className,
    children = param.children,
    localDomain = param.localDomain;
  var _useFlyout = useFlyout(),
    activeFlyout = _useFlyout.activeFlyout,
    toggleFlyout = _useFlyout.toggleFlyout;
  var _useLocation = _sliced_to_array(useLocation(), 1),
    pathname = _useLocation[0].pathname;
  var locale = useLocalization().locale;
  var isCurrent = url && buildUrl([pathname]).match(buildUrl(["/".concat(url)]));
  return (attributes === null || attributes === void 0 ? void 0 : attributes.enabled) ? /*#__PURE__*/React.createElement("li", {
    className: classNames(className, {
      "is-active": (attributes === null || attributes === void 0 ? void 0 : attributes.ariaControls) === activeFlyout,
      "is-current": isCurrent
    })
  }, /*#__PURE__*/React.createElement(Link, {
    href: dynamicUrl(url, attributes === null || attributes === void 0 ? void 0 : attributes.id, localDomain, locale),
    title: attributes === null || attributes === void 0 ? void 0 : attributes.title,
    "aria-haspopup": true,
    "aria-controls": attributes === null || attributes === void 0 ? void 0 : attributes.ariaControls,
    "aria-expanded": activeFlyout === (attributes === null || attributes === void 0 ? void 0 : attributes.ariaExpanded),
    accessKey: attributes === null || attributes === void 0 ? void 0 : attributes.accessKey,
    target: (attributes === null || attributes === void 0 ? void 0 : attributes.target) || "_self",
    id: attributes === null || attributes === void 0 ? void 0 : attributes.id,
    className: classNames(attributes === null || attributes === void 0 ? void 0 : attributes.class, {
      "has-childs": childItems === null || childItems === void 0 ? void 0 : childItems.length,
      "is-active": (attributes === null || attributes === void 0 ? void 0 : attributes.ariaControls) === activeFlyout,
      "is-current": isCurrent
    }),
    onClick: function onClick(event) {
      if (attributes === null || attributes === void 0 ? void 0 : attributes.ariaControls) {
        toggleFlyout(attributes === null || attributes === void 0 ? void 0 : attributes.ariaControls);
        event.preventDefault();
        event.stopPropagation();
      }
      _onClick && _onClick(event);
    }
  }, children ? children : /*#__PURE__*/React.createElement("span", null, title)), childItems && childItems.length > 0 && /*#__PURE__*/React.createElement("ul", childMenuAttributes, childItems.map(function (childItem) {
    return /*#__PURE__*/React.createElement(MenuItem, _object_spread({
      key: "".concat(childItem.id),
      childMenuAttributes: childMenuAttributes,
      className: className
    }, childItem));
  }))) : null;
};